import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

if (environment.production) {
  console.log('Running in production mode');
} else {
  console.log(`Running in ${environment.environmentName} mode`);
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
